import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/theme.css";

import { BUILD_STAMP } from "./buildStamp";

import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Non-UI side effect: keep the stamp in the compiled bundle.
// Avoids coupling the UI to any specific API hostname.
(window as any).__VERITYEDGE_BUILD_STAMP = BUILD_STAMP;
